// Per-tier contextual messaging for the results panel.
// Source: git show origin/seller:src/App.js lines 203..235.

export const tierContextMap = {
  'Ultra-Premium': {
    description:
      'Your dataset is in the top tier — comparable to the most valuable healthcare data assets in the world.',
    deals:
      'Comparable deals: Flatiron-Roche ($950/patient), UK Biobank ($260/patient), NIH All of Us ($4,321/participant)',
    typical:
      'Datasets here typically have deep multi-modal linkage, large sample sizes, longitudinal outcomes, and broad commercial consent.',
  },
  Premium: {
    description:
      'Your dataset commands premium pricing — you have strong negotiating leverage with pharma and AI buyers.',
    deals:
      'Comparable deals: FinnGen ($250/patient), Tempus Total ($137.50/patient), Geisinger-Regeneron ($167–333/patient)',
    typical:
      'Datasets here typically have high-quality genomics or multi-omics, linked clinical outcomes, and research-grade consent.',
  },
  'High-Value': {
    description:
      'Your dataset is above average and has clear commercial value. Buyers will engage, but exclusivity and enrichment can push you higher.',
    deals: 'Comparable deals: 23andMe-GSK ($74/patient), Tempus-AZ ($25/patient)',
    typical:
      'Datasets here typically have good linkage and moderate sample sizes, but may lack some modalities or have consent limitations.',
  },
  Standard: {
    description:
      'Your dataset has solid commercial potential. Focus on strengthening linkage and compliance to move into higher tiers.',
    deals:
      'Reference: Tempus-GSK Extension ($9/patient), HealthVerity ($0.30/life annually at massive scale)',
    typical:
      'Datasets here are commercially viable but face competition. Differentiators like exclusivity and enrichment are important.',
  },
  Competitive: {
    description:
      'Your dataset has moderate value. Consider investing in data quality, linkage, or consent scope to increase your pricing power.',
    deals: 'Reference: Claims-based datasets typically command $3–7/life annually at large scale',
    typical:
      'Datasets here often have limited linkage, smaller cohorts, or restricted consent. Improvements in any of these areas can lift your tier.',
  },
  Entry: {
    description:
      'Your dataset is at entry-level pricing. This is common for early-stage biobanks or datasets with limited linkage and scope.',
    deals:
      'Reference: Academic biobank access fees typically range $20K–75K/year for standard access',
    typical:
      'Datasets here may have a single data type, limited sample size, or disease-specific consent. Start with academic partnerships to build track record.',
  },
};
